import { Component, OnInit } from '@angular/core';
import { NavController } from '@ionic/angular';
import { CartQantityService } from 'src/app/services/cart.service';


@Component({
  selector: 'app-float-cart',
  templateUrl: './float-cart.component.html',
  styleUrls: ['./float-cart.component.scss'],
})
export class FloatCartComponent implements OnInit {
  quantity: number = 0
  constructor(
    private _cartQuantityService: CartQantityService,
    private nav: NavController,
  ) { }

  ngOnInit() {
    this._cartQuantityService.cartQantity.subscribe((response) => {
      this.quantity = response.quantity
    })
  }

  goTo(page) {
    this.nav.navigateForward(page);
  }
}